module.exports = __webpack_public_path__ + "img/prize-03.e0dbc9ba.png";